import { render, staticRenderFns } from "./diff_line_note_form.vue?vue&type=template&id=0795491e&"
import script from "./diff_line_note_form.vue?vue&type=script&lang=js&"
export * from "./diff_line_note_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports